var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyChooseIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.636 17.1869L22.656 28.5549C22.6786 28.6888 22.6598 28.8263 22.6021 28.9492C22.5445 29.0721 22.4506 29.1745 22.3332 29.2426C22.2158 29.3108 22.0804 29.3414 21.945 29.3305C21.8097 29.3196 21.681 29.2676 21.576 29.1816L16.8026 25.5989C16.5722 25.4267 16.2923 25.3337 16.0046 25.3337C15.717 25.3337 15.4371 25.4267 15.2066 25.5989L10.4253 29.1802C10.3204 29.2661 10.1918 29.318 10.0566 29.3289C9.92148 29.3399 9.7862 29.3093 9.66886 29.2414C9.55151 29.1734 9.45767 29.0713 9.39987 28.9487C9.34206 28.826 9.32302 28.6886 9.34531 28.5549L11.364 17.1869",
    stroke: "#EFEFEF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6666C20.4183 18.6666 24 15.0849 24 10.6666C24 6.24835 20.4183 2.66663 16 2.66663C11.5817 2.66663 8 6.24835 8 10.6666C8 15.0849 11.5817 18.6666 16 18.6666Z",
    stroke: "#EFEFEF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseIcon6);
export default __webpack_public_path__ + "static/media/why-choose-icon-6.678dcd4a22c82bd2a1f052774d714840.svg";
export { ForwardRef as ReactComponent };